import { Esercizio } from "./Esercizio";
import { Sessione } from "./Sessione";

export const isValidEsercizio = (esercizio: Esercizio) => {
  const baseValid =
    esercizio.full_name?.trim() &&
    esercizio.full_description?.trim() &&
    esercizio.position &&
    esercizio.purpose &&
    esercizio.execution &&
    esercizio.mode &&
    esercizio.muscle_groups?.length > 0 &&
    esercizio.posture &&
    esercizio.gravity_management_complexity > 0 &&
    esercizio.motor_coordination_complexity > 0 &&
    esercizio.cardiorespiratory_complexity > 0;

  const extraValidForExercise =
    esercizio.type !== "Exercise" ||
    (
      esercizio.animation &&
      esercizio.body_tracking
    );

  return (baseValid && extraValidForExercise);
};



